import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { UIGameMapCornerView } from './UIGameMapCornerView.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { TileCornerBuildingType } from '@colonist/game-states';
import { Point } from '@colonist/game-mechanic-validators';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { ArrayUtils } from '@colonist/utils';
export class UIGameMapMetropolisController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.MapStateUpdated:
                this.drawMetropolises(data == false);
                break;
            case UIGameEventEnums.RobberMoved:
                this.setMetropolisLayer();
                break;
            default:
                break;
        }
    }
    drawMetropolises(drawExistingMetropolises) {
        this.removeStolenMetropolises();
        for (const corner of this.uiGameManager.gameState.mapState.tileState.tileCorners){
            if (corner.buildingType != TileCornerBuildingType.City) continue;
            if (!corner.doesCornerHaveMetropolis()) continue;
            if (this.cornerExists(corner)) continue;
            this.drawMetropolisOnCorner(corner, drawExistingMetropolises);
        }
    }
    removeStolenMetropolises() {
        const metropolisViews = [
            ...this.metropolisViews
        ];
        for (const metropolisView of metropolisViews){
            if (metropolisView.corner.doesCornerHaveMetropolis()) continue;
            metropolisView.parent.removeChild(metropolisView);
            ArrayUtils.removeElementFromArray(this.metropolisViews, metropolisView);
        }
    }
    cornerExists(corner) {
        for (const metropolisView of this.metropolisViews){
            if (metropolisView.corner.sameCorner(corner)) return true;
        }
        return false;
    }
    drawMetropolisOnCorner(corner, drawExistingMetropolis) {
        const metropolisBonus = corner.getMetropolis();
        if (metropolisBonus == undefined) return;
        const texture = UIGameSpriteHandler.getMetropolisForCornerBonusType(metropolisBonus);
        const mapView = this.uiGameManager.mapController.mapView;
        const center = corner.hexCorner.toPixel(mapView.mapCenter, mapView.hexagonHeight / 2);
        const x = center.x - mapView.cornerCircleR * 0.47;
        const y = center.y - mapView.cornerCircleR * 1.285;
        const animationStartY = drawExistingMetropolis ? y : y - mapView.hexagonHeight;
        const w = this.uiGameManager.mapController.mapView.cornerCircleR * 2;
        const h = w;
        const layer = mapView.layers.metropolis;
        const metropolisView = new UIGameMapCornerView(corner, x, animationStartY, w, h, layer, texture, mapView);
        const hexCorner = new Point(metropolisView.x, y);
        metropolisView.animationController.animationCompleteCallBack = ()=>{
            if (drawExistingMetropolis) return;
            if (this.uiGameManager.gameController.isReplay) return;
            AudioManager.play(AudioType.MetropolisPlace);
        };
        metropolisView.animationController.animateTo(hexCorner);
        this.metropolisViews.push(metropolisView);
        this.uiGameManager.mapController.mapView.sortChildren();
        this.setMetropolisLayer();
    }
    setMetropolisLayer() {
        if (this.robberState == undefined) return;
        const robberTile = this.uiGameManager.gameState.mapState.tileState.tiles[this.robberState.locationTileIndex];
        this.adjustLayeringOnMetropolisIcons(robberTile);
    }
    adjustLayeringOnMetropolisIcons(newRobberTile) {
        const mapView = this.uiGameManager.mapController.mapView;
        for (const metropolisView of this.metropolisViews){
            const metropolisCorner = metropolisView.corner.hexCorner;
            for (const touchingCorner of newRobberTile.hexFace.corners()){
                if (!touchingCorner.sameCorner(metropolisCorner)) continue;
                const isTouchingCornerNorthWest = touchingCorner.x == newRobberTile.hexFace.x && touchingCorner.y == newRobberTile.hexFace.y - 1;
                const halfALayer = 0.5;
                const newMetropolisLayer = isTouchingCornerNorthWest ? mapView.layers.robber - halfALayer : mapView.layers.metropolis;
                metropolisView.zIndex = newMetropolisLayer;
            }
        }
        mapView.sortChildren();
    }
    constructor(uiGameManager, robberState){
        this.metropolisViews = [];
        this.uiGameManager = uiGameManager;
        this.robberState = robberState;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.metropolisViews = [];
        this.drawMetropolises(true);
    }
}
